import * as Immutable from "immutable";
import Grantee from "./Grantee";
export default class SharedEntity {
  constructor(id, owners, title, type) {
    this._value = { id, owners, title, type };
  }
  get id() {
    return this._value.id;
  }
  get owners() {
    return this._value.owners;
  }
  get title() {
    return this._value.title;
  }
  get type() {
    return this._value.type;
  }
  toBuilder() {
    const { id, owners, title } = this._value;
    return new Builder(Immutable.Map({ id, owners, title }));
  }
  toJSON() {
    const { id, owners, title, type } = this._value;
    return { id, owners, title, type };
  }
  static fromJSON(value) {
    const { id, owners, title, type } = value;
    const formattedOwners = Immutable.fromJS(owners.map((o) => Grantee.fromJSON(o)));
    return SharedEntity.builder().id(id).owners(formattedOwners).title(title).type(type).build();
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  owners(value) {
    return new Builder(this.value.set("owners", value));
  }
  title(value) {
    return new Builder(this.value.set("title", value));
  }
  type(value) {
    return new Builder(this.value.set("type", value));
  }
  build() {
    const { id, owners, title, type } = this.value.toObject();
    return new SharedEntity(id, owners, title, type);
  }
}
